<template>
  <div class="content-box">
    <div class="content-bottom-box">
      <div class="desc-box">
        <p class="d-text-small d-text-black">{{descItem1}}</p>
        <p class="d-text-small d-text-grey">{{descItem2}}</p>
        <div class="select-box-outer">
          <div ref="motorFactroyCombobox">
            <select-combobox
              :dataArr="motorFactoryList"
              keyValue="motor_manuf_code"
              displayValue="motor_manuf_name"
              :placeholder="factoryPlaceholder"
              :selectedAlready="selectedFactoryName"
              :closeAllCombobox="closeAllCombobox"
              :noData="showFactoryNodata?factoryNodata:''"
              :idealHeight="motorFactoryComboxHeight"
              @open-combobox="openCombobox"
              @get-combobox-data="getMotorFactoryList"
              @select-item="selectMotorFactory"
              :pages="factoryPages"
              :currentPage="currentFactoryPage"
              :totalPages="totalFactoryPages"
              @select-page="selectFactoryPage"
              @change-page="prevOrNextFactory"
            ></select-combobox>
          </div>
          <div ref="motorModelCombobox">
            <select-combobox
              class="select-box-2"
              v-if="selectedFactoryCode"
              :dataArr="motorModelList"
              keyValue="motor_model_code"
              displayValue="motor_model_name"
              :placeholder="modelPlaceholder"
              :selectedAlready="selectedModelName"
              :closeAllCombobox="closeAllCombobox"
              :noData="showModelNodata?modelNodata:''"
              :idealHeight="motorModelComboxHeight"
              @open-combobox="openCombobox"
              @get-combobox-data="getMotorModelList"
              @select-item="selectMotorModel"
              :pages="modelPages"
              :currentPage="currentModelPage"
              :totalPages="totalModelPages"
              @select-page="selectModelPage"
              @change-page="prevOrNextModel"
            ></select-combobox>
          </div>
        </div>
        <p v-show="selectedFactoryCode" class="d-text-small d-text-grey">* {{descItem3}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  mounted() {
    this.$store.commit({
      type: "setTitle",
      text: this.$t("modelTitle"),
      showRightBtn: false
    });
    setTimeout(() => {
      this.btnHidden = false;
    }, 350);
    let motorFactroyCombobox = this.$refs.motorFactroyCombobox;
    // console.log(motorFactroyCombobox);
    let start =
      motorFactroyCombobox.getBoundingClientRect().top +
      motorFactroyCombobox.offsetHeight;
    let end = window.innerHeight - 120 - 66;
    this.motorFactoryComboxHeight = end - start;
    let motorModelCombobox = this.$refs.motorModelCombobox;
    // console.log(motorModelCombobox);
    let start2 =
      motorModelCombobox.getBoundingClientRect().top +
      motorFactroyCombobox.offsetHeight;
    let end2 = window.innerHeight - 120 - 66;
    this.motorModelComboxHeight = end2 - start2;
  },
  data() {
    return {
      page: "model",
      http: "https",
      ip: "public-app-web-api.ictun.com",
      // ip: "172.19.1.144:8088",
      api: "/public-app-web-api/com-web/alcidae",
      descItem1: this.$t("modelDescItem1"),
      descItem2: this.$t("modelDescItem2"),
      descItem3: this.$t("modelDescItem3"),
      descTips: this.$t("modelDescTips"),
      btnDesc: this.$t("btnNext"),
      btnHidden: false,
      factoryPlaceholder: this.$t("factoryPlaceholder"),
      modelPlaceholder: this.$t("modelPlaceholder"),
      factoryNodata: this.$t("commonNodata"),
      modelNodata: this.$t("commonNodata"),
      closeAllCombobox: false,
      showFactoryNodata: false,
      showModelNodata: false,
      motorFactoryComboxHeight: 200,
      motorModelComboxHeight: 200,
      selectedFactoryCode: "",
      selectedModelCode: "",
      selectedFactoryName: "",
      selectedModelName: "",
      motorFactoryList: [],
      motorModelList: [],
      currentFactoryPage: 1,
      totalFactoryPages: 1,
      currentModelPage: 1,
      totalModelPages: 1
    };
  },
  computed: {
    selectedFactory: {
      get: function() {
        let code = this.selectedFactoryCode;
        let name = this.selectedFactoryName;
        return {
          motor_manuf_code: code,
          motor_manuf_name: name
        };
      },
      set: function(itemObj) {
        if (itemObj.motor_manuf_code) {
          this.selectedFactoryCode = itemObj.motor_manuf_code;
          this.selectedFactoryName = itemObj.motor_manuf_name;
        } else {
          this.selectedFactoryCode = "";
          this.selectedFactoryName = "";
        }
      }
    },
    selectedModel: {
      get: function() {
        let code = this.selectedModelCode;
        let name = this.selectedModelName;
        return {
          motor_model_code: code,
          motor_model_name: name
        };
      },
      set: function(itemObj) {
        if (itemObj.motor_model_code) {
          this.selectedModelCode = itemObj.motor_model_code;
          this.selectedModelName = itemObj.motor_model_name;
        } else {
          this.selectedModelCode = "";
          this.selectedModelName = "";
        }
      }
    },

    factoryPages(){
      return this.getPages(this.currentFactoryPage,this.totalFactoryPages);
    },

    modelPages(){
      return this.getPages(this.currentModelPage,this.totalModelPages);
    },
  },
  methods: {
    getPages(currentPage,totalPages){
      let cur = currentPage;
      let total = totalPages;
      if(total <= 4){
        let arr = new Array(total);
        for(let i=1; i<=total; i++){
          arr[i-1] = i;
        }
        return arr;
      }
        if (cur < 3) {
          return [1, 2, 3, "...", total];
        } else if(cur == 3){
          if(total == 5){
            return [1, 2, 3, 4, 5];
          }else{
            return [1, 2, 3, 4, "...", total];
          }
        }else if (cur > total - 2) {
          return [1, '...', total-2, total-1, total]
        } else if (cur == total - 2) {
          return [1, '...',total-3, total-2, total-1, total]
        } else {
          return [1, '...',cur-1, cur, cur+1, '...', total]  //第三种情况
        }
    },
    selectFactoryPage(item){
      console.log(item);
      if (item === this.currentFactoryPage) return
      if ((typeof item) === 'string') return
      this.currentFactoryPage = item
      this.getMotorFactoryList();
    },
    prevOrNextFactory(n) {
      let currentFactoryPage = this.currentFactoryPage;
      // this.currentPage += n
      this.currentFactoryPage += n
      this.currentFactoryPage < 1
      ? this.currentFactoryPage = 1
      : this.currentFactoryPage > this.totalFactoryPages
      ? this.currentFactoryPage = this.totalFactoryPages
      : null
      if(currentFactoryPage != this.currentFactoryPage){
        this.getMotorFactoryList();
      }
    },
    selectModelPage(item) {
      console.log(item);
      if (item === this.currentModelPage) return
      if ((typeof item) === 'string') return
      this.currentModelPage = item
      this.getMotorModelList();
    },
    prevOrNextModel(n) {
      let currentModelPage = this.currentModelPage;
      // this.currentModelPage += n
      this.currentModelPage += n
      this.currentModelPage < 1
      ? this.currentModelPage = 1
      : this.currentModelPage > this.totalModelPages
      ? this.currentModelPage = this.totalModelPages
      : null
      if(currentModelPage != this.currentModelPage){
        this.getMotorModelList();
      }
    },


    clickBtn(e) {
      this.showPageConnect();
    },
    showPageConnect() {
      this.$store.commit({
        type: "setMotorModel",
        motorFactroy: this.selectedFactory,
        motorModel: this.selectedModel
      });
      this.$router.push("/");
    },
    showPageTypical() {
      this.$router.replace("/" + this.page + "?from=" + this.page);
      this.$router.push({ path: "/" });
    },
    openCombobox() {
      this.$store.commit({
        type: "showClickTransMask",
        callbackFunc: this.closeAllComboboxFun
      });
    },
    selectMotorFactory(item) {
      if (this.selectedFactoryCode != item.motor_manuf_code) {
        this.selectedModel = {};
        this.motorModelList = [];
      }
      this.selectedFactory = item;
      setTimeout(() => {
        this.closeAllComboboxFun();
      }, 30);
    },
    selectMotorModel(item) {
      this.selectedModel = item;
      setTimeout(() => {
        this.closeAllComboboxFun();
      }, 30);
    },
    closeAllComboboxFun() {
      this.closeAllCombobox = true;
      setTimeout(() => {
        this.closeAllCombobox = false;
      }, 250);
      this.$store.commit("hideClickTransMask");
    },
    //选择厂商
    getMotorFactoryList() {
      let options = {};
      this.showFactoryNodata = false;
      let url =
        this.http + "://" + this.ip + this.api + "/garage_door_motor_manuf";
      console.log(url);
      axios
        .get(
          // "http://172.19.1.144:8088/public-app-web-api/com-web/alcidae/garage_door_motor_manuf",
          // this.http+'://'+this.ip+this.api+'/garage_door_motor_manuf',
          url,
          { params: { page: this.currentFactoryPage, page_size: 10 } }
        )
        .then(res => {
          console.log(res.data);
          this.motorFactoryList = res.data.body;
          if (this.motorFactoryList.length) {
            this.showFactoryNodata = false;
          } else {
            this.showFactoryNodata = true;
          }
          if(res.data.total){
            this.totalFactoryPages = Math.ceil(res.data.total/10)
            console.log(this.totalFactoryPages)
          }
        })
        .catch(err => {
          this.showFactoryNodata = true;
          console.log("getMotorFactoryList err");
          console.log(err);
        });
    },
    getMotorModelList() {
      console.log("getMotorModelList");
      let options = {
        motor_manuf_code: this.selectedFactoryCode
      };
      this.showModelNodata = false;
      let url =
        this.http +
        "://" +
        this.ip +
        this.api +
        "/garage_door_motor_manuf_model";
      console.log(url);
      axios
        .get(
          // "http://172.19.1.144:8088/public-app-web-api/com-web/alcidae/garage_door_motor_manuf_model",
          // this.http+'://'+this.ip+this.api+'/garage_door_motor_manuf_model',
          url,
          {
            params: {
              motor_manuf_code: this.selectedFactoryCode,
              page: this.currentModelPage,
              page_size: 10
            }
          }
        )
        .then(res => {
          console.log(res.data);
          if (res.data.body) {
            this.motorModelList = res.data.body;
          }
          // this.processMotorFactoryList(res.body);
          if (this.motorModelList.length) {
            this.showModelNodata = false;
          } else {
            this.showModelNodata = true;
            console.log("111");
          }
          if(res.data.total){
            this.totalModelPages = Math.ceil(res.data.total/10)
            console.log(this.totalModelPages)
          }
        })
        .catch(err => {
          this.showModelNodata = true;
          console.log("getMotorModelList err");
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.desc-box {
  padding: 11px 20px 16px 20px;
  overflow: visible;
}
.select-box-outer {
  margin: 11px 18px;
}
.select-box-2 {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/guide/model.vue